import React from 'react';
import { connect } from 'react-redux';

import { entitySelectors } from '@store/entity/selectors';
import { yourJourneySelectors } from '@store/yourJourney/selectors';

import { SpaClassesV2 } from './SpaClassesV2';
import { SpaClassesV2OwnProps, SpaClassesV2StoreProps } from './SpaClassesV2.types';

const mapStateToProps = (state): SpaClassesV2StoreProps => ({
  property: entitySelectors.getProperty(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
});

export const SpaClassesV2Connected: React.ComponentType<SpaClassesV2OwnProps> =
  connect(mapStateToProps)(SpaClassesV2);
